module.exports = __webpack_public_path__ + "img/EVA.3514976f.jpeg";